import axios from "axios";
import { combinedUrls } from "../../URL/functions";
import { ttProtectionUrls } from "../../URL/ApplicationUrls";

export function useCreateTtProtectionWithFtlRoutes() {
  return async function createTtProtectionWithFtlRoute(selectedRoutes: number[]) {
    const response = await axios.post<number | undefined>(
      combinedUrls(ttProtectionUrls.base.apiUrl, "/CopyFtlRoutesToTTProtection"),
      selectedRoutes
    );
    if (!response.data) {
      throw new Error("Error: Generate TT Protection failed and TTProtectionId is undefined");
    }
    return { newTtProtectionId: response.data };
  };
}
